/**
 * Generated by orval 🍺
 * Do not edit manually.
 * CliniShift Manager
 * The CliniShift Manager API is used to manage the CliniShift platform. This API is used by the CliniShift Manager Portal.
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';




export const Id = zod.string().min(1).describe('A unique identifier for the resource.\n\n> This field is a string but the format of the value is not confirmed.\n>\n> *WIP*: The format of this field is not finalised or strictly defined.\n> This field may contain a simple ID in string format such as `"1"` or it may contain a UUID like `"a091dcb6-6e99-4e51-a8ee-69f67bcf2858"`');

export type Id = zod.input<typeof Id>;
export type IdOutput = zod.output<typeof Id>;
